export default __webpack_public_path__ + "static/media/mail.f42281e8.svg";